import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

let scrollTrigger;

const scrollTo = function(targetSlide){
  gsap.to(window, {
    scrollTo: { y: targetSlide, autoKill: false },
    duration: 0.5
  });
}

const snapScroll = function(){
  // const sections = document.querySelectorAll(".wrapper-pdp:not(.d-none) .image-carousel-col .product-slide"); 
  // scrollTrigger = ScrollTrigger.create({
  //   trigger: ".image-carousel-col .swiper-wrapper",
  //   start: "top top",
  //   end: "bottom bottom",
  //   snap: {
  //     snapTo: 1 / (sections.length - 1), // progress increment
  //     ease: "power3",
  //     duration: {min: 0.2, max: 3}
  //   },
  //   scrub: 0.5
  // });

  const rightColumn = document.querySelector(".details-column-content");
  if (rightColumn) {
    const rightColumnBounds = rightColumn.getBoundingClientRect();
    const outOfScreenPart = rightColumnBounds.height - window.innerHeight - rightColumnBounds.y;
    const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');

    let rightColumnOriginalWidth;
    ScrollTrigger.create({
      trigger: rightColumn,
      scrub: true,
      //markers: true,
      start: "top top+=" + headerHeight.trim(),
      endTrigger: ".image-carousel-col .product-slide:last-child",
      end: "bottom bottom-=" + outOfScreenPart,
      onToggle: self => {
        rightColumnOriginalWidth = rightColumn.clientWidth;
        rightColumn.style.width =  self.isActive ? rightColumnOriginalWidth + 'px' : '';
        rightColumn.style.position =  self.isActive ? 'fixed' : '';
      },
      onLeave: () => {
        rightColumn.style.paddingTop = window.scrollY + 'px';
      },
      onEnterBack: () => {
        rightColumn.style.paddingTop = '';
      }
    })
  }
}


const refresh = function(){
  scrollTrigger && scrollTrigger.kill();
  snapScroll();
}

const bindEvents = function(){
  snapScroll();
}


export {bindEvents, scrollTo, refresh};